export interface Client {
  name: string
  logo: string | null
  location: string
  industry: string
  format: string
  projectId: string | null
}

export const clients: Client[] = [
  {
    name: 'Narra Health',
    logo: 'https://cdn.magicpatterns.com/uploads/ocLvdZc71ZNKULum6ZLUwF/Group_4.svg',
    location: 'PH / Singapore / Berlin',
    industry: 'Health & Wellness',
    format: 'Web App',
    projectId: 'narra',
  },
  {
    name: 'Invesko',
    logo: 'https://cdn.magicpatterns.com/uploads/gzpUxwdPjU3oPvmSCR2wMS/Group_18.svg',
    location: 'Singapore',
    industry: 'Fintech',
    format: 'Mobile App (Android/iOS)',
    projectId: 'invesko',
  },
  {
    name: 'OPUS',
    logo: null,
    location: 'London',
    industry: 'Social',
    format: 'Web, Brand',
    projectId: 'opus',
  },
  {
    name: 'FootID Pro',
    logo: null,
    location: 'Riverside, California',
    industry: 'Health & Medical, B2B Ops',
    format: 'Web App, Mobile App',
    projectId: 'kevinroot',
  },
  {
    name: 'KevinRoot Medical',
    logo: null,
    location: 'Riverside, California',
    industry: 'B2B Ops',
    format: 'Web App, Mobile App',
    projectId: 'kevinroot',
  },
  {
    name: 'Kinhub',
    logo: 'https://cdn.magicpatterns.com/uploads/awHy4mzbEbrupQxFR7WVZ7/Group.svg',
    location: 'London',
    industry: 'Health & Wellness',
    format: 'Web App',
    projectId: 'kinhub',
  },
  {
    name: 'Sarisuki',
    logo: null,
    location: 'Manila',
    industry: 'E-Commerce, B2B Ops',
    format: 'Web App, Mobile App',
    projectId: 'sarisuki',
  },
  {
    name: 'Become',
    logo: null,
    location: 'Madrid',
    industry: 'Educational',
    format: 'Web, Brand',
    projectId: 'become',
  },
  {
    name: 'Museo del Galeón',
    logo: null,
    location: 'Manila',
    industry: 'Cultural',
    format: 'Website, Print Collaterals',
    projectId: 'museo-del-galeon',
  },
  {
    name: 'Mind What Matters',
    logo: 'https://cdn.magicpatterns.com/uploads/x5SPAFmdV3DPBmszavcJvt/Group_1948754876.svg',
    location: 'Singapore',
    industry: 'Health & Wellness',
    format: 'Web, Print Collaterals',
    projectId: 'mind-what-matters',
  },
  {
    name: 'Humble',
    logo: null,
    location: 'Manila',
    industry: 'B2B',
    format: 'Brand Collaterals',
    projectId: 'humble',
  },
  {
    name: 'xchange',
    logo: 'https://cdn.magicpatterns.com/uploads/71Lro4NoAkxFCFdAzLk97j/Group_1948755017.svg',
    location: 'Manila',
    industry: 'Finance',
    format: 'Print Collaterals',
    projectId: 'xchange',
  },
  {
    name: 'RIFE',
    logo: 'https://cdn.magicpatterns.com/uploads/pNdj8CivscfqTY54NqSnGq/Group_96.svg',
    location: 'Manila',
    industry: 'Educational',
    format: 'Print Collaterals',
    projectId: 'rife',
  },
  {
    name: 'Just One Run',
    logo: null,
    location: 'Manila',
    industry: 'Sport & Recreation',
    format: 'Print Collaterals',
    projectId: 'just-one-run',
  },
]
